import Footer from "./footer";
import Navbar from "./navbar";

const Disclaimer = () => {
	return (
		<>
			<Navbar />
			{/* <Homecarousel/> */}
			{/* <div className="container-fluid bg-primary py-5 mb-5 page-header">
				<div className="container py-5">
					<div className="row justify-content-center">
						<div className="col-lg-10 text-center">
							<h1 className="display-3 text-white animated slideInDown">
								Disclaimer
							</h1>
							<nav aria-label="breadcrumb">
								<ol className="breadcrumb justify-content-center">
									<li className="breadcrumb-item">
										<a className="text-white" href="index.php">
											Home
										</a>
									</li>
									<li
										className="breadcrumb-item text-white active"
										aria-current="page">
										Disclaimer
									</li>
								</ol>
								<a href="index.php" className="btn btn-success btn-sm">
									Go Back
								</a>
							</nav>
						</div>
					</div>
				</div>
			</div> */}
			<div className="approach-container">
				<div className="approach-inner">
					<h1>Disclaimer</h1>
					<b>Global Academy For Food Safety and Sustainability Standards</b>
					<br />
					<i>A division of Krishigap Digital Solutions Pvt. Ltd.</i>
					<p>
						Website:{" "}
						<a
							target="_blank"
							rel="noreferrer"
							href="https://www.globalfoodstandards.in/">
							www.globalfoodstandards.in
						</a>
					</p>

					<div className="approach-content">
						<div className="approach-left">
							<div className="approach-item">
								<h3>Purpose of the Portal</h3>
								<p className="approach-description">
									This platform has been developed to support farmers and small
									and medium food enterprises (SMEs)—particularly in rural areas
									and developing countries—who face challenges in accessing
									training, guidance, and resources for implementing food safety
									and sustainability standards.
									<br />
									<br />
									We recognize that certification bodies and standard publishers
									are unable to offer direct consultancy or implementation
									support due to conflict-of-interest policies. This gap has
									motivated us to create a knowledge-sharing platform to
									facilitate broader awareness, capacity-building, and easier
									access to relevant resources.
								</p>
							</div>

							<div className="approach-item">
								<h3>Key Objectives</h3>
								<ul className="ticked-list">
									<li>
										Empower a skilled workforce — Equip farmers and processors
										to meet global standards.
									</li>
									<li>
										Drive higher incomes — Unlock premium market access for
										certified produce.
									</li>
									<li>
										Champion safe, sustainable food — Build trust through
										quality and compliance.
									</li>
									<li>
										Enhance climate resilience — Enable carbon credits and
										sustainable growth.
									</li>
									<li>
										Strengthen global food security — Position India as a leader
										in safe, sustainable food.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>Acknowledgement of Standards and Sources</h3>
								<ul className="approach-list">
									<li>
										We fully respect and acknowledge the integrity and ownership
										of all food safety and sustainability standards publishers.
									</li>
									<li>
										Where applicable, we provide direct links to the official
										websites of standard publishers for purchasing or accessing
										their documents. We do not host any copyrighted standards on
										our platform.
									</li>
									<li>
										Where standards are available for free download, we refer to
										the respective official sources for user convenience.
									</li>
									<li>
										All references, tools, and documents are provided solely for
										educational and guidance purposes and do not substitute for
										official standard documents.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>Content Ownership and Usage</h3>
								<ul className="approach-list">
									<li>
										Krishigap Digital Solutions Pvt. Ltd. does not claim
										ownership over all content or third-party components
										presented on this platform.
									</li>
									<li>
										Users are responsible for obtaining appropriate permissions
										or licenses for the reuse of any third-party materials.
									</li>
									<li>
										Templates (e.g., Quality Manuals, SOPs, Record Formats)
										provided are for general guidance only and must be
										customized to the user's specific processes, products,
										regulatory requirements, and customer needs.
									</li>
									<li>
										Standards may be periodically updated. Users are advised to
										verify and refer to the latest versions through official
										publisher websites.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>Disclaimer of Liability</h3>
								<ul className="approach-list">
									<li>
										The information and resources on this platform are compiled
										to the best of our knowledge but are not guaranteed for
										accuracy, completeness, or reliability.
									</li>
									<li>
										Krishigap Digital Solutions Pvt. Ltd., including its
										founders, directors, subject experts, advisory members, and
										employees, shall not be liable for any direct, indirect,
										incidental, consequential, or punitive damages, including,
										but not limited to, loss of profits, revenue, or data
										resulting from the use of this platform.
									</li>
									<li>
										This platform does not provide legal, investment, or
										business advice. Users are solely responsible for any
										decisions made based on the materials provided.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>External Links</h3>
								<ul className="approach-list">
									<li>
										This website may contain links to external websites operated
										by third parties.
									</li>
									<li>
										Such links are provided for reference only. Krishigap
										Digital Solutions Pvt. Ltd. is not responsible for the
										content, accuracy, or policies of any external sites.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>Advisory to Users</h3>
								<p className="approach-description">
									Users are strongly encouraged to:
								</p>
								<ul className="approach-list">
									<li>
										Refer to the official websites of standard publishers and
										regulatory bodies for current and updated information.
									</li>
									<li>
										Purchase or download official versions of standards directly
										from the publishers (e.g., GlobalG.A.P., IndG.A.P.,
										Rainforest Alliance, USDA NOP, NPOP, ISO, FSSC, BRCGS).
									</li>
									<li>
										Consult qualified professionals when implementing any food
										safety or sustainability standard.
									</li>
								</ul>
								<b>Examples of Key Official Sources:</b>
								<ul className="approach-list">
									<li>
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.globalgap.org/">
											www.globalgap.org
										</a>{" "}
										(GlobalG.A.P)
									</li>
									<li>
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.ams.usda.gov/">
											www.ams.usda.gov
										</a>{" "}
										(USDA NOP)
									</li>
									<li>
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.apeda.gov.in/">
											www.apeda.gov.in
										</a>{" "}
										(www.apeda.gov.in)
									</li>
									<li>
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.iso.org/">
											www.iso.org
										</a>{" "}
										(International Standards)
									</li>
									<li>
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.fssc.com/">
											www.fssc.com
										</a>{" "}
										{", "}
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.brcgs.com/">
											www.brcgs.com
										</a>{" "}
										{", "}
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.rainforest-alliance.org/">
											www.rainforest-alliance.org
										</a>
										{", "}
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.fairtrade.net/">
											www.fairtrade.net
										</a>
									</li>
									<li>
										<a
											target="_blank"
											rel="noreferrer"
											href="https://www.qcin.org/">
											www.qcin.org
										</a>{" "}
										(Quality Council of India)
									</li>
									<li>
										Agricultural universities, ICAR institutions, and other
										relevant government bodies
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h2>NO WARRANTY | NO GUARANTEE | NO LIABILITY</h2>
								<p className="approach-description">
									All content is provided "<strong>as is</strong>" without any
									warranties, guarantees, or representations of any kind.
									<br />
									By using this platform, users agree to these terms and
									conditions.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<Footer />
			</div>
		</>
	);
};

export default Disclaimer;
